// Route constants
export const VEHICLE_TYPE_LIST_ROUTE = '/vehicle-type';

// Message keys for Ant Design message component
export const BULK_UPLOAD_MESSAGE_KEY = 'bulk-upload';
export const BULK_UPLOAD_PROCESS_MESSAGE_KEY = 'bulk-upload-process';

// Bulk upload configuration
export const BULK_UPLOAD_CONFIG = {
	entity: 'vehicle_type_bulk_upload_v2',
	title: 'Bulk Upload Vehicle Types',
	description:
		'Upload a CSV file containing vehicle type information. The file should include columns for vehicle type name, capacity, length, temperature control, maker/manufacturer, vehicle category, driver mode, fuel type, and description.',
	templateUrl:
		'https://logitrack-assets.s3.ap-south-1.amazonaws.com/templates/vehicle_type_bulk_upload_template.csv',
	templateText: 'Download the CSV template here:',
	acceptedFormats: '.csv',
	maxSizeMB: 10,
};
